module.exports = __webpack_public_path__ + "img/dick1-cover-2.8f2f6133.jpg";